import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableRow,
  TableHead,
} from "@mui/material";

import "./styles/Status.css";

function StatusProjectNotes(props) {
  if (props.message) {
    const messageArray = props.message.split(/<br\s*\/?>/i);

    return (
      <Box sx={{ textAlign: "center" }}>
        <Box className="statusTableTitle">Notes</Box>
        {messageArray.map((elem, index) => (
          <div key={index} style={{ textAlign: "left", margin: "0px 10px" }}>
            {elem}
            <br></br>
          </div>
        ))}
      </Box>
    );
  }
}

export default StatusProjectNotes;

StatusProjectNotes.propTypes = {
  message: PropTypes.string,
};

/*
     <table className="statusTable">
        <tr className="statusTableRow">
          <td className="statusTableColumnHeader">Metric</td>
          <td className="statusTableColumnHeader">Value</td>
        </tr>
        <tr className="statusTableRow">
          <td className="statusTableCell">
            Actual {props.metricsObject.suffix}
          </td>
          <td className="statusTableCell">{props.metricsObject.actualValue}</td>
        </tr>
      </table>
      */
